export default function getEventCardLink({
  registrationLink,

  pageLink,
}) {
  return registrationLink || pageLink;
}
